import createEntityDuck from '../../util/genericEntityDuck';

const namespace = 'settings';
const storeKey = 'organizations';

const duck = createEntityDuck(namespace, storeKey, 'organizationId', namespace);

export { duck as default, storeKey };
export const { creators, reducer, types, selectors, initialState } = duck;
